import { getPointOnLine } from './getPointOnLine';
import { Line, SvgLine } from './types';

export function getSvgLine(line: Line, length: number): SvgLine {
  const x1 = -length / 2;
  const x2 = length / 2;

  const v1 = getPointOnLine(line, x1);
  const v2 = getPointOnLine(line, x2);

  return {
    x1: v1.x,
    x2: v2.x,
    y1: v1.y,
    y2: v2.y,
  };
}
